import { Map, List } from 'immutable';

import Text           from 'components/Generic/Inputs/Text';
import Video          from 'components/Generic/Inputs/Video';
import Audio          from 'components/Generic/Inputs/Audio';
import AudioText      from 'components/Generic/Inputs/AudioText';
import FileUpload     from 'components/LandingPage/Answers/Inputs/FileUpload';
import Picture        from 'components/Generic/Inputs/Picture';
import MultipleChoice from 'components/Generic/Inputs/MultipleChoice';
import Number         from 'components/Generic/Inputs/Number';
import Geolocation    from 'components/Generic/Inputs/Geolocation';
import Dropdown       from 'components/Generic/Inputs/Dropdown';
import PlayMedia      from 'components/Generic/Inputs/PlayMedia';
import Booking        from 'components/LandingPage/Answers/Inputs/Booking';

import { isValidEmail, isValidName } from 'helpers/string';

export function questionTypeSelector(type) {
  const components = {
    short_text:        Text,
    text:              Text,
    number:            Number,
    'multiple choice': MultipleChoice,
    'audio/text':      AudioText,
    audio:             Audio,
    picture:           Picture,
    video:             Video,
    file_upload:       FileUpload,
    geolocation:       Geolocation,
    dropdown:          Dropdown,
    play_media:        PlayMedia,
    booking:           Booking,
  };

  if (components[type] === undefined) return null;

  return components[type];
}

export function errorSelector(element) {
  const errs = [];
  const mapping = {
    firstName: t('guests.interview.input.first_name'),
    lastName:  t('guests.interview.input.last_name'),
    email:     t('guests.interview.input.email'),
    msisdn:    t('guests.interview.input.phone_number'),
  };

  const invalidEmail = element.target.name === 'email' && !isValidEmail(element.target.value);
  const invalidName  = ['firstName', 'lastName'].includes(element.target.name) && !isValidName(element.target.value);

  // TODO: Actual error could be defined here if needed. For now we only
  // show an error indicator in the text field
  if (invalidEmail || invalidName) {
    errs.push(mapping[element.target.name]);
  }

  return errs;
}

export const staticQuestions = new List([
  // new Map({
  //   id: 1,
  //   title: 'Do a voice impersonation of Spongebob Squarepants',
  //   categoryName: 'audio'
  // }),
  // new Map({
  //   id: 2,
  //   title: 'Record yourself dancing to Despacito',
  //   categoryName: 'video'
  // }),
  // new Map({
  //   id: 3,
  //   title: 'Record yourself dancing to Despacito',
  //   categoryName: 'audio/text'
  // }),
  // new Map({
  //   id: 4,
  //   title: 'Record yourself dancing to Despacito',
  //   categoryName: 'multiple choice',
  //   options: new List(['what', 'when'])
  // }),
  new Map({
    id:     5,
    prompt: {
      id:           5,
      title:        'File upload',
      categoryName: 'file_upload',
    },
  }),
  new Map({
    id:     6,
    prompt: {
      id:           6,
      title:        'Picture upload',
      categoryName: 'picture',
    },
  }),
]);
